<template>
	<ElSwitch
		:id="id"
		v-model="checked"
		:active-text="activeText"
		:inactive-text="inactiveText"
		:disabled="disabled"
		class="app-switch"
		:class="activeText.length || inactiveText.length ? 'el-switch--labels' : null"
		:name="name"
	/>
</template>

<script>
	import { Switch } from '@cognitoforms/element-ui';

	export default {
		name: 'CSwitch',
		components: {
			ElSwitch: Switch
		},
		model: {
			prop: 'value',
			event: 'input'
		},
		props: {
			disabled: { type: Boolean, default: false },
			activeText: { type: String, default: '' },
			inactiveText: { type: String, default: '' },
			value: { type: Boolean, required: true },
			id: { type: String, default: null },
			name: { type: String, default: null }
		},
		emits: ['input'],
		computed: {
			checked: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('input', val);
				}
			}
		}
	};
</script>

<style lang="scss">
// Change the size by adding a font-size class on the component instance. E.g. sz-4
$base-size: 12px;
$speed: .3s;

.app-switch {
	display: inline-flex;
	position: relative;
	align-items: center;
	height: 1.6em;
	cursor: pointer;

	.el-switch__input {
		position: absolute;
		width: 0;
		height: 0;
		margin: 0;
		opacity: 0;
	}

	&.is-checked .el-switch__core {
		background-color: var(--bg-selected-intense);
		border-color: var(--border-selected-intense);
	}

	.el-switch--labels {

		.el-switch__core {
			margin: 0 math.div($gutter, 4);
		}
	}

	.el-switch__core {
		display: inline-block;
		position: relative;

		// need to override Element's inline sytle
		width: $base-size * 3.5 !important;
		height: $base-size * 2;
		background: var(--bg-switch-off);
		border: 1px solid var(--bg-switch-off);
		border-radius: $base-size * 10;
		outline: none;
		vertical-align: middle;
		transition: border-color .3s, background-color .3s;
	}

	&.is-checked .el-switch__input:focus ~ .el-switch__core {
		box-shadow: 0 0 0 2px var(--shade-10);
	}

	.el-switch__input:focus ~ .el-switch__core {
		box-shadow: 0 0 0 2px var(--outline-focused);
	}

	.el-switch__label {
		border-bottom: 1px solid transparent;
		padding-bottom: 1px;
		font-size: $size__2;
		font-weight: normal;
		transition: $speed;
	}

	.is-active {
		border-bottom-color: var(--border-selected-intense);
	}

	$switchTranslate: translateX(calc(100% - 1px));

	@mixin switch-bg() {
		display: flex;
		position: absolute;
		left: 2px;
		top: 2px;
		align-items: center;
		justify-content: center;
		width: 19px;
		height: 19px;
		content: '';
		transition: $speed;
	}

	&.is-checked .el-switch__core::before {
		transform: $switchTranslate;
	}

	.el-switch__core::before {
		@include switch-bg;
		background-color: var(--bg-primary);
		border-radius: 100%;
	}

	.el-switch__core::after {
		@include switch-bg;
		mask-image: url('data:image/svg+xml,%3Csvg%20width%3D%2217%22%20height%3D%2217%22%20viewBox%3D%220%200%2017%2017%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20id%3D%22check%22%3E%3Cpath%20id%3D%22stroke%22%20d%3D%22M15.5%203.5L5.875%2012.8333L1.5%208.52564%22%20stroke%3D%22%2309a098%22%20stroke-width%3D%221.04314%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
		mask-position: center;
		mask-repeat: no-repeat;
		mask-size: 12px 12px;
	}

	&.is-checked .el-switch__core::after {
		background: var(--icon-intense);
		transform: $switchTranslate;
	}
}

</style>